/** Константы и хелперы OAuth authorize для мобильного клиента. */

export const OAUTH_CLIENT_ID = 'insfamily-mobile'
export const OAUTH_REDIRECT_URI = 'insfamily://auth/callback'
/** Должен совпадать с OAUTH_REDIRECT_URI_WHITELIST на бэке. */
export const OAUTH_REDIRECT_URI_WHITELIST = [
  'insfamily://auth/callback',
  'http://localhost:5173/auth/callback',
  'https://app.insfamily.ru/auth/callback',
  'https://app.insfamily.ru/messenger/auth/callback',
]
export const OAUTH_RESPONSE_TYPE = 'code'
export const OAUTH_CODE_CHALLENGE_METHOD = 'S256'

const OAUTH_ERROR_MESSAGES = {
  unsupported_response_type: 'Неподдерживаемый тип ответа OAuth.',
  invalid_client: 'Неверный OAuth-клиент.',
  invalid_redirect_uri: 'Неверный redirect URI.',
  invalid_request: 'Некорректные параметры OAuth. Откройте вход из приложения.',
}

/** Страница открыта как OAuth authorize (путь или полный набор query). */
export function isOAuthAuthorizePage() {
  const { pathname, search } = window.location
  if (pathname.includes('/oauth/authorize')) return true

  const params = new URLSearchParams(search)
  return (
    params.has('response_type') &&
    params.has('client_id') &&
    params.has('redirect_uri') &&
    params.has('code_challenge') &&
    params.has('code_challenge_method') &&
    params.has('state')
  )
}

/** Читает OAuth query со страницы. */
export function getOAuthParams() {
  const params = new URLSearchParams(window.location.search)
  return {
    response_type: params.get('response_type'),
    client_id: params.get('client_id'),
    redirect_uri: params.get('redirect_uri'),
    state: params.get('state') ?? '',
    code_challenge: params.get('code_challenge'),
    code_challenge_method: params.get('code_challenge_method'),
  }
}

/**
 * Проверяет обязательные OAuth-параметры против whitelist.
 * @returns {string|null} код ошибки или null, если всё ок
 */
export function validateOAuthParams(params) {
  if (params.response_type !== OAUTH_RESPONSE_TYPE) return 'unsupported_response_type'
  if (params.client_id !== OAUTH_CLIENT_ID) return 'invalid_client'
  if (!OAUTH_REDIRECT_URI_WHITELIST.includes(params.redirect_uri)) {
    return 'invalid_redirect_uri'
  }
  if (!params.code_challenge || params.code_challenge_method !== OAUTH_CODE_CHALLENGE_METHOD) {
    return 'invalid_request'
  }
  if (!params.state) return 'invalid_request'
  return null
}

/** Текст ошибки OAuth для UI. */
export function getOAuthErrorMessage(errorCode) {
  return OAUTH_ERROR_MESSAGES[errorCode] || OAUTH_ERROR_MESSAGES.invalid_request
}

/** Редирект в мобилку с authorization code. */
export function redirectToOAuthCallback({ redirect_uri, code, state }) {
  window.location.href =
    `${redirect_uri}?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`
}

const OAUTH_TOKENS_KEY = 'insfamily.oauth.tokens'

/**
 * Пишет access/refresh в localStorage для CRM-клиента.
 * Профиль отдельно не сохраняем — клиент тянет его с /oauth/userinfo/.
 */
export function saveOAuthTokens({ accessToken, refreshToken, expiresAt }) {
  if (!accessToken || !refreshToken || expiresAt == null) return
  localStorage.setItem(
    OAUTH_TOKENS_KEY,
    JSON.stringify({ accessToken, refreshToken, expiresAt }),
  )
}
